import React from 'react'
import { Skeleton, Card, Button, notification, Progress, Tooltip, Icon, message } from 'antd'
import Upload from '../Upload'
import gql from '../../api/gql'
import _ from 'lodash'
import PrintFilePreview from '../file/PrintFilePreview'
import styled from 'styled-components'
import { CLOUDFRONT_URL,CLOUDFRONT_URL_CUSTOM, ACCESS_KEY_PRINT_FILE_PREVIEW, API_URL } from '../../config';
import {all} from "redux-saga/effects";
import PrintFileDownload from "../file/PrintFileDownload";
import Axios from 'axios'

const Container = styled.div`
  .ant-upload.ant-upload-select.ant-upload-select-text{
    width:100%;
  }
  .btn-a1{
    width: 100%;margin-bottom: 10px;
    background: #8f8f8f;
    color: white;
    border: none;
  }
  .btn-a{
    width: 100%;margin-bottom: 10px;
    background: #8f8f8f;
    color: white;
    border: none;
  }
  .btn-a:hover{
    background: #8f8f8f;
    color: white;
    border: none;
  }
  .pod-file-download{
    position: absolute;
    font-size: 14px;
    bottom: 12px;
    right: 8px;
    border-radius: 50%;
    background-color:#ff6666;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    i{
      color: #FFF;
    }
  }
  .print_files{
    display: grid;
    grid-template-columns: repeat(4, auto);
    gap: 10px;
  }
  @media only screen and (max-width: 600px) {
    .print_files{
      grid-template-columns: repeat(3, auto);
    }
  }
`
const UploadContainer = styled.div`
  position: relative;
  height:0;
  padding-bottom:67%;
  .upload-wrapper{
    display: block;
    position: relative;
    height: 0;
    padding-bottom:67%;
    .upload-area{
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background: #ccc;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`
class UploadDesign extends React.Component {
  state = {
    file: this.props.file,
    uploading: false,
    percent: 0,
  }

  onUpload = file => {
    let query = `mutation createFile($input: NewFile!){
      createFile(input: $input){id}
    }`
    gql.request(query, {
      input: {
        source: 'aws',
        key: file.key,
        file_name: file.file.name,
        file_mime: file.file.type,
        file_size: file.file.size,
      }
    }).then(({ createFile }) => {
      const { file } = this.state
      this.setState({
        uploading: false,
        file: { ...file, file_id: createFile.id }
      }, () => this.props.onChange(this.state.file))
    }).catch(err => {
      this.setState({
        uploading: false,
        percent: 0
      })
    })
  }

  beforeUpload = (file, fileList) =>{
    var regex = new RegExp("^(\\d|\\w)+(.jpg|.jpeg|.png|.tiff|.tif|.psd)$")
    var result = regex.test(file.name);
    if (result===false){
      message["error"]("File name cannot contain empty space or any special characters")
      return false
    }else{
      return true
    }
  }

  render() {
    const { file, uploading, percent } = this.state
    return (
      <UploadContainer>
        <Upload
          beforeUpload={this.beforeUpload}
          onUpload={this.onUpload}
          onProcess={e => {
            this.setState({
              uploading: true,
              percent: Math.round(e.loaded / e.total * 100)
            })
          }}
          fileList={false}
          accept=".jpg, .png, .tiff, .psd"
          className="upload-wrapper">
          <div className="upload-area">
            {uploading ?
              <Progress type="circle" percent={percent} strokeColor="#1890ff" width={50} /> :
              (file.file_id ? <PrintFilePreview file_id={file.file_id} /> : <span style={{ textAlign: 'center' }}>Missing, click to upload or drag to upload</span>)
            }
          </div>
        </Upload>
        <div>
          {uploading ?
              <Progress type="circle" percent={percent} strokeColor="#1890ff" width={50} /> :
              (file.file_id ? <PrintFileDownload file_id={file.file_id} /> : "")
          }
        </div>
      </UploadContainer>
    )
  }
}

export default class UploadCustomDesigns extends React.Component {
  state = {
    product: null,
    printFiles: [],
    loading: true,
    percent: 0,
    submitLoading: false,
    submitReadyLoading: false,
    uploadLoading: false,
    acceptLoading: false,
    acceptReadyLoading: false,
    statusReloadFile: false,
    loadingDom: false,
    loadingPrintFile: false
  }

  componentDidMount() {
    this.loadPrintFiles()
  }

  loadPrintFiles = () => {
    const { order } = this.props
    this.setState({
      loadingDom: true
    })
    const pTPrintFiles = order.variant.product_type.print_files
    const orderPrintFiles = order.print_files
    const productTypeVariantId = order.variant.product_type_variant.id
    let printFiles = []
    if (!orderPrintFiles || orderPrintFiles.length === 0) {
      //need to get print file from product type
      if(pTPrintFiles){
        printFiles = pTPrintFiles.filter(ptp => _.includes(ptp.variant_ids, productTypeVariantId) || ptp.variant_ids == null || ptp.variant_ids.length ==0)
      }else{
        this.setState({
          statusReloadFile: true
        })
      }
      //console.log("test", test)
    }else{
      //get print files from order
      printFiles = order.print_files
    }
    this.setState({
      printFiles: printFiles,
      loading: false
    })
  }
  handleReloadFile = () => {
    const {order} = this.props
    let mutation = `mutation refreshOrder($order_id: Int!){
      refreshOrder(order_id: $order_id){
        id
      }
    }`;

    gql.request(mutation, {
      order_id: order.id,
    }).then(res => {
      notification['success']({
        message: 'Reload successful'
      })
      this.loadPrintFiles();
      this.props.onClose()
    }).catch(err => {
      notification['error']({
        message: _.get(err, '[0].message')
      })
    })

  }
  savePrintFiles = (e, isReady) => {
    e.preventDefault()
    if(isReady){
      this.setState({ submitReadyLoading: true })
    }else{
      this.setState({ submitLoading: true })
    }
    
    const { printFiles } = this.state
    const { order } = this.props
    let query = `mutation UpdateOrderPrintFiles($order_id: Int!, $print_files: [OrderPrintFileInput!], $is_ready: Boolean!){
      updateOrderPrintFiles(order_id: $order_id, print_files: $print_files, is_ready: $is_ready)
    }`

    gql.request(query, {
      order_id: order.id,
      print_files: printFiles.map(printFile => _.omit(printFile, ['file', 'variant_ids'])),
      is_ready: isReady
    }).then(res => {
      notification['success']({
        message: 'Print Files saved'
      })
      this.props.onClose()
    }).catch(err => {
      if(isReady){
        this.setState({ submitReadyLoading: false })
      }else{
        this.setState({ submitLoading: false })
      }
      notification['error']({
        message: _.get(err, '[0].message')
      })
    })
  }
  acceptPrintFiles = (e, isReady) => {
    e.preventDefault()
    if(isReady){
      this.setState({ acceptReadyLoading: true })
    }else{
      this.setState({ acceptLoading: true })
    }
    const { order } = this.props

    if(order.product_custom == false){
      this.setState({acceptLoading: false})
      notification['error']({
        message: 'Not a Personalized product'
      })
    }else{
      let query = `mutation applyOrderPrintFile($order_id: Int!){
        applyOrderPrintFile(order_id: $order_id)
      }`

      gql.request(query, {
        order_id: order.id,
      }).then(res => {
        notification['success']({
          message: 'Accept Print Files Successful'
        })
        this.props.onClose()
      }).catch(err => {
        if(isReady){
          this.setState({ acceptReadyLoading: false })
        }else{
          this.setState({ acceptLoading: false })
        }
        notification['error']({
          message: _.get(err, '[0].message')
        })
      })
    }

  }

  handLoadPrintFilePreview = async () => {
    this.setState({
      loadingPrintFile: true
    });
    const { order, currentUser } = this.props;
    // ACCESS_KEY_PRINT_FILE_PREVIEW, URL_API_CALL_PRINT_FILE_PREVIEW
    const order_id = Number(order.id);
    const body = {
      order_id,
      access_key: ACCESS_KEY_PRINT_FILE_PREVIEW,
      user_name: `${currentUser.first_name || ''} ${currentUser.last_name || ''}`,
      auto: false
    }
    try {
      const getFrintFile = await Axios.post(`${API_URL}/rest/call-lambda-print-file`, body).then(res => {
        return res.data;
      });
      if(getFrintFile?.message == 'OK'){
        message.success("Success!");
        this.setState({
          printFiles: [],
          loadingPrintFile: false
        });
        await this.loadPrintFiles();
        // await this.handleReloadFile();
        this.props.onClose(order.id);
        this.setState({
          loadingPrintFile: false
        });
      }else if(getFrintFile?.message == 'AGAIN'){
        message.info("Size is too big, please try again a few times.!");
        this.setState({
          loadingPrintFile: false
        });
      }else{
        // await this.loadPrintFiles();
        // await this.handleReloadFile();
        // this.props.onClose(order.id);
        this.setState({
          loadingPrintFile: false
        });
      }
      
    } catch (error) {
      this.setState({
        loadingPrintFile: false
      });
    }
    
  }
  render() {
    const { printFiles, loading, statusReloadFile, loadingPrintFile } = this.state
    const { order } = this.props
    let compser_print_file = order.print_files_product_custom.replace(CLOUDFRONT_URL_CUSTOM+"/upload-custom/","")

    if (loading || !order) {
      return <Skeleton />
    }
    return (
      <Container>
        {loadingPrintFile ? 
        <Skeleton active /> 
        : <>
        <div className="print_files">
          {statusReloadFile && <div style={{
                border: '1px solid #dbdbdb',
                display: 'flex',
                borderRadius: '3px',
                justifyContent: 'center',
                alignItems: 'center'
          }}>
            <Button type='primary' onClick={this.handleReloadFile}>Reload File</Button>
          </div>}
          {printFiles && printFiles.map((print_file, index) => (
            <div key={index}>
              <Card
                hoverable
                cover={(
                  <UploadDesign file={print_file} onChange={file => {
                    const { printFiles } = this.state
                    printFiles[index] = file
                    this.setState({ printFiles })
                  }}/>
                )}
              >
                <Card.Meta title={print_file.title} description={`${print_file.width} x ${print_file.height}`} />
                {print_file.note && <Card.Meta title={null} description={print_file.note} />}
                {print_file.file && <div className="pod-file-download">
                  <a href={`${CLOUDFRONT_URL}/${print_file.file.key}`} rel="noopener noreferrer" target="_blank" title="Download Print File">
                    <Tooltip placement="topRight" title="Download print file">
                      <Icon type="download"></Icon>
                    </Tooltip>
                  </a>
                </div>
                }
              </Card>
              <a style={{display:"grid"}} href={order.print_file_order} target="_blank"><Button type="primary" style={{
                width: "100%",marginTop: 10,height: 35
              }}>Print File Custom</Button></a>
              <a href={`${(order.preview_product_custom.indexOf('d1g5m92ae2p29v.cloudfront.net') >= 0) ? order.preview_product_custom : CLOUDFRONT_URL_CUSTOM + '/' + order.preview_product_custom}`} alt="" style={{ width: "40%" }} target="_blank"><Button type="primary" style={{
                width: "100%",marginTop: 10,height: 35, background: "#4867d6",borderColor:"#4867d6"
              }}>Customer Preview</Button></a>
            </div>
          ))}
          {/*Show File in product custom*/}
          {(order.product_custom == true && order.print_files_product_custom.includes("cloudfront.net") == true) &&
            <div>
              <Card hoverable style={{ width: 210,marginLeft:30 }}cover={<img style={{height:145}} alt="example" src={order.print_files_product_custom}  />}>
                <a href={`${order.print_files_product_custom}`} target="_blank"><button type={"button"} className="ant-btn ant-btn-primary btn-a1">View Print File</button></a>
                {order.compress_print_files_product_custom_preview && 
                 <a href={`${order.compress_print_files_product_custom_preview}`} target="_blank"><button type={"button"} style={{background: "#007bff"}} className="ant-btn ant-btn-default btn-a1">Check Print File</button></a>
                }
                {/*<a href={`https://bs753hlclf.execute-api.ap-southeast-1.amazonaws.com/img/?order_id=${order.origin_id}&url=${compser_print_file}`} target="_blank"><button type={"button"} className="ant-btn ant-btn-primary btn-a1">Print File</button></a>*/}
                {/*<a href={`${CLOUDFRONT_URL_CUSTOM}/${order.preview_product_custom}`} target="_blank"><button type={"button"} className="ant-btn ant-btn-info btn-a">Customer Preview</button></a>*/}
              </Card>
            </div>
          }
          {order.compress_print_files_product_custom && <>
            {(!order.print_files_product_custom) &&
              <Button loading={loadingPrintFile} onClick={this.handLoadPrintFilePreview} type='primary'>Render PrintFile</Button>
            }
          </>}
          {/* <Button loading={loadingPrintFile} onClick={this.handLoadPrintFilePreview} type='primary'>Print File Preview</Button> */}

        </div>
        
        {order.product.images && order.product.images.length > 0 && <div>
          <h4 style={{ marginTop: 50 }}>Product Mockup</h4>
          {order?.preview_product_custom != "" ? 
            <img src={`${(order.preview_product_custom.indexOf('d1g5m92ae2p29v.cloudfront.net') >= 0) ? order.preview_product_custom : CLOUDFRONT_URL_CUSTOM + '/' + order.preview_product_custom}`} alt="" style={{ width: "40%" }} />
          : 
            <img src={order.product.images ? order.product.images[0] : null} alt="" style={{ width: "40%" }} />
          } 
        </div>}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
          }}
        >
          {/*Accpect File In Personalized*/}
          {order.product_custom == true && order.print_files == null  &&
            <Button disabled={!order.print_files_product_custom} type="button" 
            style={{background: !order.print_files_product_custom ? "#33333360" :"#42ad16",color:"white",marginRight:"10px",border:"none"}}
                    onClick={(e) => {this.acceptPrintFiles(e,false)}}
                    loading={this.state.acceptLoading}>Accept Print File</Button>
          }
          {/* <Button type="primary" onClick={this.savePrintFiles} loading={this.state.submitLoading}>Save</Button> */}
          <Button type="primary" onClick={(e)=>{
            this.savePrintFiles(e, false)
          }} 
            loading={this.state.submitLoading}>Save</Button>

          {order && (order.status === "sup_rejected" || order.status === "sup_failed") && <Button type="primary" onClick={(e)=>{
            this.savePrintFiles(e, true)
          }} 
            loading={this.state.submitReadyLoading} style={{marginLeft: "5px"}}>Save and Ready</Button>}
        </div>
        </>
      }
        
      </Container>
    )
  }
}